import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const HomeBuilding: Site = {
  id: 'homebuilding',
  logo: 'svg/homebuilding.svg',
  label: 'Home Building',
  analyticsName: 'homebuilding',
  hostname: 'homebuilding.co.uk',
  platform: 'responsive',
  selector: `article a, ${responsiveVanillaSelector}`,
};
